import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-catalogo',
  templateUrl: './publicidad.component.html',
  styleUrls: ['./publicidad.component.css']
})
export class PublicidadComponent implements OnInit {


    local:string;
    url:string;
    urlSafe: SafeResourceUrl;
    id_pais:string;
    constructor(public sanitizer: DomSanitizer) { }
    ngOnInit(): void {
      this.id_pais=localStorage.getItem("id_pais");
      if(this.id_pais=='593'){
        this.url="http://62.171.172.148:8111/arbolArchivo/?ruta=/ecuador/publicidad";
        this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
        }else{
          this.url="http://62.171.172.148:8111/arbolArchivo/?ruta=/panama/publicidad";
          this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
             
        }
    }
  
  
   
  
  }
  



